import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import { getStorage } from "../../utils/storage";
import {
  fetchMerchantFiles,
  viewUploadedFile,
} from "../../queries/files/fileQuery";
import icons from "../../constants/icons";
import toastMessage from "../../utils/toastMessage";
import axios from "axios";

class MyFiles extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 1,
    search_text: "",
    selected_data: {},
    error: {},
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    this.getData(true);
  };

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoading });

      const files = await fetchMerchantFiles(defaultLanguage);

      const data = await Promise.all(
        files.map(async (file) => {
          const url = await viewUploadedFile(defaultLanguage, {
            fileId: file.id,
          });
          return {
            ...file,
            tmpURL: url,
          };
        })
      );

      this.setState({
        isLoading: false,
        data: data,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e.target.value,
      error,
    });
  }

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].name,
        key: "fileType",
      },
      {
        title: "",
        key: "multiple-actions",
        actions: [
          {
            icon: icons.download,
            title: "Download",
            onPress: (item) => window.open(item.tmpURL, "_blank"),
          },
          // {
          //   icon: icons.delete,
          //   title: "Delete",
          //   iconColor: "red",
          //   onPress: (item) => this.handleRemoveFile(item),
          // },
        ],
      },
    ];

    return headers;
  }

  // check with the backend make sure delete is working
  // handleRemoveFile = async (file) => {
  //   if (window.confirm("Are you sure you want to delete this file?")) {
  //     let { data, user } = this.state;

  //     data.splice(data.indexOf(file), 1);

  //     this.setState({ data });

  //     try {
  //       const options = {
  //         method: "DELETE",
  //         url: endPoint + "/file",
  //         data: {
  //           fid: file.id,
  //           vtId: file.fileTypeId,
  //         },
  //         headers: {
  //           Authorization: "Bearer " + user.token,
  //         },
  //       };

  //       await axios(options);

  //       toastMessage(
  //         "success",
  //         language[this.props.defaultLanguage].filed_deleted_successfully
  //       );
  //       this.getData(false);
  //     } catch (error) {
  //       toastMessage(
  //         "error",
  //         language[this.props.defaultLanguage].unable_delete_file
  //       );
  //     }
  //   }
  // };

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          page={this.state.page}
          limit={this.state.limit}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(MyFiles);
